const validatePricingData = (pricingData, pricingGroup) => {
  const { productId, productId2 } = pricingData;

  const validPricingGroup = productId2
    ? Number(pricingData[productId][pricingGroup] && Number(pricingData[productId2][pricingGroup]))
    : Number(pricingData[productId][pricingGroup]);

  return validPricingGroup;
};

const renderLegacyPrice = (pricingContainers, pricingData = {}, pricingGroup = '') => {
  const hasPricingData = validatePricingData(pricingData, pricingGroup);

  if (hasPricingData) {
    [...pricingContainers].forEach((pricingEl) => {
      const id = pricingEl.dataset.product;
      const priceValue = pricingEl.querySelector('.cmp-pricing__price-value');
      const priceValueHidden = pricingEl.querySelector('.cmp-pricing__price-value--hidden');
      const price = pricingData[id][pricingGroup];

      const splitFitmentContainer = document.querySelector('.pdp-pricing__split-fitment-wrapper');
      const pricingContainer = document.querySelector('.pdp-pricing__pricing-wrapper');

      if (price) {
        priceValue.innerHTML = price;
        priceValueHidden.innerHTML = price;
        pricingEl.classList.remove('util-display-none');

        if (splitFitmentContainer) {
          splitFitmentContainer.classList.remove('util-display-none');
        } else if (pricingContainer) {
          pricingContainer.classList.remove('util-display-none');
        }
      }
    });
  } else {
    const pricingCall = document.querySelector('.pdp-pricing__call');
    const limitedStock = document.querySelector('.pdp-pricing__stock__pdp');
    pricingCall?.classList?.remove('util-display-none');
    limitedStock?.classList?.remove('util-display-none');
  }
};

const renderPrice = (pricingContainers, pricing) => {
  if (pricing.isValidPrice) {
    [...pricingContainers].forEach((pricingEl) => {
      const id = pricingEl.dataset.product;
      const priceValue = pricingEl.querySelector('.cmp-pricing__price-value');
      const priceValueHidden = pricingEl.querySelector('.cmp-pricing__price-value--hidden');
      const price = pricing[id];

      const splitFitmentContainer = document.querySelector('.pdp-pricing__split-fitment-wrapper');
      const pricingContainer = document.querySelector('.pdp-pricing__pricing-wrapper');

      if (price) {
        priceValue.innerHTML = price;
        priceValueHidden.innerHTML = price;
        pricingEl.classList.remove('util-display-none');

        if (splitFitmentContainer) {
          splitFitmentContainer.classList.remove('util-display-none');
        } else if (pricingContainer) {
          pricingContainer.classList.remove('util-display-none');
        }
      } else {
        const pricingCall = document.querySelector('.pdp-pricing__call');
        const limitedStock = document.querySelector('.pdp-pricing__stock__pdp');
        const pricingElem = document.querySelector('.pdp-pricing__cart');
        pricingCall?.classList?.remove('util-display-none');
        limitedStock?.classList?.remove('util-display-none');
        pricingElem?.classList?.add('util-display-none');
      }
    });
  } else {
    const pricingCall = document.querySelector('.pdp-pricing__call');
    const limitedStock = document.querySelector('.pdp-pricing__stock__pdp');
    const pricingElem = document.querySelector('.pdp-pricing__cart');
    pricingCall?.classList?.remove('util-display-none');
    limitedStock?.classList?.remove('util-display-none');
    pricingElem?.classList?.add('util-display-none');
  }
};

export {
  renderLegacyPrice,
  renderPrice,
};
